WiseMetering.Views.ShowNavigatorConfiguration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integration_configurations/navigator/show',
    title: () => i18next.t('modal.title.integration_configurations.show')

    // edit: function() {
    //     new WiseMetering.Views.EditNavigatorConfiguration({ model: this.model });
    // }
});
